(function () {
  'use strict';

  var TARGET_OPTION_LABEL = 'Default Products';


  // ============================================================
  // CSS
  // ============================================================

  var style = document.createElement('style');

  style.textContent = `
    .easify-default-products-hidden {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      max-height: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      overflow: hidden !important;
      pointer-events: none !important;
    }
  `;

  document.head.appendChild(style);


  // ============================================================
  // NORMALIZE TEXT
  // ============================================================

  function normalizeText(text) {

    return (text || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  }


  // ============================================================
  // FIND DEFAULT PRODUCTS SECTIONS
  // ============================================================

  function getDefaultProductsSections() {

    var sections = [];

    var labels =
      document.querySelectorAll('.po-label-label');


    labels.forEach(function (label) {

      var labelText =
        normalizeText(label.textContent);

      var targetText =
        normalizeText(TARGET_OPTION_LABEL);


      if (labelText !== targetText) {
        return;
      }


      var optionRoot =
        label.closest('.po-option-root');


      if (!optionRoot) {
        return;
      }


      if (
        sections.indexOf(optionRoot) === -1
      ) {

        sections.push(optionRoot);

      }

    });


    return sections;

  }


  // ============================================================
  // HIDE DEFAULT PRODUCTS
  // ============================================================

  function hideDefaultProductsOption() {

    var sections =
      getDefaultProductsSections();


    sections.forEach(function (section) {

      section.classList.add(
        'easify-default-products-hidden'
      );


      section.style.setProperty(
        'display',
        'none',
        'important'
      );

      section.style.setProperty(
        'visibility',
        'hidden',
        'important'
      );

      section.style.setProperty(
        'height',
        '0',
        'important'
      );

      section.style.setProperty(
        'margin',
        '0',
        'important'
      );

      section.style.setProperty(
        'padding',
        '0',
        'important'
      );

    });

  }


  // ============================================================
  // DETERMINE IF CHECKBOX CAN BE SELECTED
  // ============================================================

  function canSelectCheckbox(checkbox) {

    if (!checkbox) {
      return false;
    }


    if (checkbox.disabled) {
      return false;
    }


    if (
      checkbox.hasAttribute('disabled')
    ) {
      return false;
    }


    if (
      checkbox.getAttribute('aria-disabled') === 'true'
    ) {
      return false;
    }


    /*
     * Check parent containers for disabled
     * or sold-out states.
     */
    var parent =
      checkbox.closest(
        '.po-checkbox-root,' +
        '.po-checkboxOption-root,' +
        '.po-option-value'
      );


    if (parent) {

      var parentText =
        normalizeText(parent.textContent);


      if (
        parentText.indexOf('sold out') !== -1
      ) {

        return false;

      }


      if (
        parent.classList.contains('disabled') ||
        parent.classList.contains('po-disabled')
      ) {

        return false;

      }

    }


    return true;

  }


  // ============================================================
  // CLICK CHECKBOX
  // ============================================================

  function tryClick(checkbox) {

    return new Promise(function (resolve) {

      /*
       * Already selected.
       */
      if (checkbox.checked) {

        resolve(true);

        return;

      }


      /*
       * Do not select unavailable options.
       */
      if (!canSelectCheckbox(checkbox)) {

        resolve(true);

        return;

      }


      try {

        checkbox.click();

      } catch (error) {

        console.error(
          '[Easify Default Products] Checkbox click failed:',
          error
        );

        resolve(false);

        return;

      }


      /*
       * Give Easify time to process
       * the selection.
       */
      setTimeout(function () {

        resolve(
          checkbox.checked
        );

      }, 100);

    });

  }


  // ============================================================
  // PRESELECT DEFAULT PRODUCTS
  // ============================================================

  async function preSelectDefaultProducts() {

    var sections =
      getDefaultProductsSections();


    if (!sections.length) {

      return false;

    }


    var allSuccessful = true;


    for (
      var sectionIndex = 0;
      sectionIndex < sections.length;
      sectionIndex++
    ) {

      var section =
        sections[sectionIndex];


      /*
       * Re-hide before working with it.
       */
      section.classList.add(
        'easify-default-products-hidden'
      );


      var checkboxes =
        section.querySelectorAll(
          '.po-checkboxOption-checkbox'
        );


      if (!checkboxes.length) {

        continue;

      }


      for (
        var i = 0;
        i < checkboxes.length;
        i++
      ) {

        var checkbox =
          checkboxes[i];


        if (!canSelectCheckbox(checkbox)) {

          continue;

        }


        if (!checkbox.checked) {

          var success =
            await tryClick(checkbox);


          if (!success) {

            allSuccessful = false;

          }

        }

      }

    }


    return allSuccessful;

  }


  // ============================================================
  // RUN EVERYTHING
  // ============================================================

  async function runAll() {

    /*
     * Hide first so customer doesn't
     * see Default Products.
     */
    hideDefaultProductsOption();


    /*
     * Auto-select all available items.
     */
    await preSelectDefaultProducts();


    /*
     * Easify may rebuild the option after
     * selections are made, so hide again.
     */
    hideDefaultProductsOption();

  }


  // ============================================================
  // FAST RETRIES
  // ============================================================

  function runWithRetries() {

    /*
     * Immediately hide.
     */
    hideDefaultProductsOption();


    var delays = [
      0,
      25,
      50,
      100,
      150,
      250,
      400,
      600,
      1000,
      1500,
      2000,
      3000
    ];


    delays.forEach(function (delay) {

      setTimeout(function () {

        runAll();

      }, delay);

    });

  }


  // ============================================================
  // MUTATION OBSERVER
  // ============================================================

  var observerTimer = null;


  var observer =
    new MutationObserver(function (mutations) {

      /*
       * Hide immediately.
       */
      hideDefaultProductsOption();


      var relevant = false;


      for (
        var i = 0;
        i < mutations.length;
        i++
      ) {

        var mutation =
          mutations[i];


        if (!mutation.addedNodes) {
          continue;
        }


        for (
          var j = 0;
          j < mutation.addedNodes.length;
          j++
        ) {

          var node =
            mutation.addedNodes[j];


          if (
            node.nodeType !== 1
          ) {

            continue;

          }


          /*
           * Check if Easify itself was added.
           */
          if (
            node.matches &&
            node.matches(
              '.po-option-root,' +
              '.po-optionSet-root,' +
              '.po-checkbox-root,' +
              '.po-checkboxOption-checkbox,' +
              '.po-label-label'
            )
          ) {

            relevant = true;

            break;

          }


          /*
           * Check if an Easify element exists
           * somewhere inside the added node.
           */
          if (
            node.querySelector &&
            (
              node.querySelector('.po-option-root') ||
              node.querySelector('.po-optionSet-root') ||
              node.querySelector('.po-checkbox-root') ||
              node.querySelector('.po-checkboxOption-checkbox') ||
              node.querySelector('.po-label-label')
            )
          ) {

            relevant = true;

            break;

          }

        }


        if (relevant) {
          break;
        }

      }


      if (!relevant) {
        return;
      }


      clearTimeout(observerTimer);


      observerTimer =
        setTimeout(function () {

          runAll();

        }, 25);

    });


  // ============================================================
  // START OBSERVER
  // ============================================================

  function startObserver() {

    if (!document.body) {
      return;
    }


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  // ============================================================
  // VARIANT CHANGE EVENTS
  // ============================================================

  var variantEvents = [

    'variant:changed',
    'variantChange',
    'variant:change',
    'product:variant-change',
    'product:variant:change'

  ];


  variantEvents.forEach(function (eventName) {

    document.addEventListener(
      eventName,
      function () {

        hideDefaultProductsOption();


        setTimeout(function () {

          runWithRetries();

        }, 50);

      }
    );

  });


  // ============================================================
  // WATCH URL CHANGES
  // ============================================================

  var lastUrl =
    window.location.href;


  setInterval(function () {

    var currentUrl =
      window.location.href;


    if (
      currentUrl === lastUrl
    ) {

      return;

    }


    lastUrl =
      currentUrl;


    hideDefaultProductsOption();


    setTimeout(function () {

      runWithRetries();

    }, 50);

  }, 250);


  // ============================================================
  // PAGE SHOW
  // ============================================================

  window.addEventListener(
    'pageshow',
    function () {

      runWithRetries();

    }
  );


  // ============================================================
  // INITIALIZE
  // ============================================================

  function initialize() {

    startObserver();

    runWithRetries();

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();

  }

})();